import styled from 'styled-components'

import { ButtonIcon, tokens } from '@arvoreeducacao/bonsai-ds'

export const ContentButton = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  cursor: pointer;
  > span {
    font-size: ${tokens.fontSize.xlarge};
  }
`

export const ButtonList = styled(ButtonIcon)<{ isInList: boolean }>`
  margin-right: ${tokens.spacing.verticalXsmall};
  padding: ${tokens.spacing.verticalMedium};
  span {
    color: ${({ isInList }) =>
      isInList ? tokens.colors.livros : tokens.colors.dark5};
  }

  &:hover {
    span {
      color: ${({ isInList }) =>
        isInList ? tokens.colors.livros : tokens.colors.dark6};
    }
  }
`
